'use client';

import { Star } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Badge } from '@/shared/ui/shadcn/badge';

interface ProjectAngleMainBadgeProps {
  className?: string;
}

export function ProjectAngleMainBadge({
  className = '',
}: ProjectAngleMainBadgeProps) {
  const t = useTranslations('angles');

  return (
    <Badge
      className={`bg-primary text-primary-foreground hover:bg-primary inline-flex items-center gap-1 ${className}`}
    >
      <Star className="h-3 w-3 fill-current" />
      <span>{t('mainBadge')}</span>
    </Badge>
  );
}
